import { StatusBadge } from "@tfg/ui"

import type { CertificateRequestDtoStatusEnumKey } from "~/gen/api"
import { useGetCertificateRequestStatus } from "~/pages/Brand/Certificates/hooks/useCertificateRequestStatusDetails"

type Props = {
  certificateRequestStatus: CertificateRequestDtoStatusEnumKey
  userType: "brand" | "supplier"
}

export function CertificateRequestStatusBadge({
  certificateRequestStatus,
  userType,
}: Props) {
  const certificateRequestStatusDetails = useGetCertificateRequestStatus(
    certificateRequestStatus,
    userType
  )
  if (!certificateRequestStatusDetails) return null
  return (
    <StatusBadge
      text={certificateRequestStatusDetails.translation}
      variant={certificateRequestStatusDetails.variant}
      icon={null}
    />
  )
}
